import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ResourceViewerModalService } from './resource-viewer-modal.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-resource-viewer-modal',
  standalone: false,
  templateUrl: './resource-viewer-modal.component.html',
  styleUrls: ['./resource-viewer-modal.component.scss']
})
export class ResourceViewerModalComponent implements OnInit {

  url$: Observable<string>;

  view$: Observable<boolean>;

  @Input()
  store: string;

  @Input()
  origen: string;

  constructor(private resourceModalService: ResourceViewerModalService) { }

  ngOnInit() {
    this.url$ = this.resourceModalService.url$;
    this.view$ = this.resourceModalService.view$;
  }

  viewToggle(view: boolean) {
    this.resourceModalService.next(view, undefined);
  }
}
